// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"horizontal__35W5m","vertical":"vertical__21b0l"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/navigation/theme.css
// module id = PRr9
// module chunks = 6